// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const deleteUserPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  id: z.number().int().describe("User id"),
});

export const deleteUserHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description user deleted
 */
export const deleteUser200Schema = z.object({});

export const deleteUserMutationResponseSchema = z.lazy(() => deleteUser200Schema);
